/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { styled } from "@mui/material";

export const ImgLoadingSpinner = styled('img')(({ loadingContent }) => ({
  width: '20px',
  height: '20px',
  margin: '0',
  display: loadingContent ? 'block' : 'none',
  verticalAlign: 'middle'
}))
